
import DepartmentCard from "./DepartmentCard";
import { Briefcase, TrendingUp, Zap, DollarSign, BarChart3, FileText, LucideIcon } from "lucide-react";

export type DepartmentData = {
  name: string;
  icon: LucideIcon;
  taskCount: number;
  completedTaskCount: number;
  color: string;
};

interface DepartmentsTabContentProps {
  departmentData: DepartmentData[];
}

const DepartmentsTabContent = ({ departmentData }: DepartmentsTabContentProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold tracking-tight">Departments</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {departmentData.map((dept) => (
          <DepartmentCard
            key={dept.name}
            name={dept.name}
            icon={dept.icon}
            taskCount={dept.taskCount}
            completedTaskCount={dept.completedTaskCount}
            color={dept.color}
          />
        ))}
      </div>
    </div>
  );
};

export default DepartmentsTabContent;
